import { Component } from '@angular/core';
import { IzzyTicketTeamMemberEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Ticket Team Members') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyticketteammember-form',
    templateUrl: './izzyticketteammember.form.component.html'
})
export class IzzyTicketTeamMemberFormComponent extends BaseFormComponent {
    public record!: IzzyTicketTeamMemberEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'membershipDetails', sectionName: 'Membership Details', isExpanded: true },
            { sectionKey: 'routingConfiguration', sectionName: 'Routing Configuration', isExpanded: true },
            { sectionKey: 'displayInformation', sectionName: 'Display Information', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

